import { Tag } from "antd";
import TableComponent from "components/table/Table";
import { apiGetCertificates } from "helpers/api/certificates";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { showToastError } from "utils";
import "./styles.scss";

// Trang chỉ để xem: quản trị viên cần biết còn bao nhiêu ngày nữa hết hạn ngay
// cả khi chưa tới ngưỡng cảnh báo, để chủ động đặt lịch gia hạn.
//
// Danh sách tên miền nạp sẵn ở BE nên ở đây không có thêm/sửa/xoá.
const LEVEL_LABEL = {
  ok: { text: "正常", color: "green" },
  warning: { text: "更新時期", color: "orange" },
  critical: { text: "至急更新", color: "red" },
  expired: { text: "期限切れ", color: "red" },
  unknown: { text: "確認できず", color: "default" },
};

const AdminSettingCertificatePage = () => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiGetCertificates()
      .then((response) => {
        if (!cancelled) {
          setCertificates(response?.data || []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          showToastError("証明書の一覧を取得できませんでした。");
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const columns = [
    {
      title: "ドメイン",
      dataIndex: "host",
      width: 200,
    },
    {
      // Cho biết tên miền nào người phụ trách phải tự gia hạn, tên miền nào
      // hệ thống cấp chứng chỉ tự làm mới.
      title: "更新方式",
      dataIndex: "auto_renew",
      width: 140,
      render: (auto) => (
        <Tag color={auto ? "blue" : "gold"}>{auto ? "自動" : "手動"}</Tag>
      ),
    },
    {
      title: "状態",
      dataIndex: "level",
      width: 110,
      render: (level) => {
        const label = LEVEL_LABEL[level] || LEVEL_LABEL.unknown;
        return <Tag color={label.color}>{label.text}</Tag>;
      },
    },
    {
      title: "残り日数",
      dataIndex: "days_until_expiry",
      width: 130,
      render: (days) =>
        days === null || days === undefined ? "-" : `${days} 日`,
    },
    {
      title: "有効期限",
      dataIndex: "not_after",
      width: 180,
      render: (value) => (value ? new Date(value).toLocaleString("ja-JP") : "-"),
    },
    {
      // Nêu ngưỡng để một tên miền còn nhiều ngày mà vẫn ở trạng thái bình
      // thường không bị hiểu nhầm là hệ thống bỏ sót.
      title: "通知開始",
      dataIndex: "warning_days",
      width: 190,
      render: (days) => (days ? `残り ${days} 日から` : "-"),
    },
    {
      title: "最終確認",
      dataIndex: "last_checked_at",
      render: (value) => (value ? new Date(value).toLocaleString("ja-JP") : "-"),
    },
  ];

  return (
    <Container fluid className="certificate-page">
      <h2 className="certificate-title">SSL証明書の有効期限</h2>
      <TableComponent
        columns={columns}
        dataSource={certificates.map((item) => ({ ...item, key: item.host }))}
        showPagination={false}
        loading={loading}
      />
    </Container>
  );
};

export default AdminSettingCertificatePage;
